import { render, staticRenderFns } from "./DeliveryHeroLines.vue?vue&type=template&id=0d80885a&"
import script from "./DeliveryHeroLines.vue?vue&type=script&lang=js&"
export * from "./DeliveryHeroLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports